// src/pages/seller/Seller2Net/services/sellerNetService.js
import api from "../../../../api/axios";

export const getUserTemplate = async (companyId) => {
  try {
    console.log("getUserTemplate")
    const res = await api.get(`/user-template/group/buyer/${companyId}`);
    return res.data?.data;
  } catch (err) {
    console.error("getUserTemplate error:", err);
    throw err;
  }
};

export const saveRefinanceCalculator = async (payload) => {
  try {
    const res = await api.post(`/refinance`, payload);
    return res.data?.data;
  } catch (err) {
    console.error("getUserTemplate error:", err);
    throw err;
  }
}

export const updateRefinanceCalculator = async (payload) => {
  try {
    const res = await api.put(`/refinance/${payload.id}`, payload);
    return res?.data?.data;
  } catch (error) {
    console.error("Update buyer calc error:", error);
    throw error;
  }
}

export const getRefinanceCalc = async (id) => {
  try {
    const res = await api.get(`/refinance/${id}`);
    return res?.data?.data;
  } catch (error) {
    console.error("Get Buyer calc error:", error);
    throw error;
  }
};

export const validateCounty = async (data) => {
  try {
    const res = await api.post(`/closing-county`, data);
    return res?.data?.data;
  } catch (err) {
    console.error("validateCounty error:", err);
    throw err;
  }
};

// Send email
export const sendEmail = async (data) => {
  try {
    const res = await api.post(`/send-sheet/email`, data);
    return res?.data;
  } catch (err) {
    console.error("sendEmail error:", err);
    throw err;
  }
};

// Send text
export const sendText = async (data) => {
  try {
    const res = await api.post(`/send-sms`, data);
    return res?.data;
  } catch (err) {
    console.error("sendText error:", err);
    throw err;
  }
};
